import React from "react";
import { installResponsiveLayout } from './responsive';

import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
installResponsiveLayout();

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          minHeight: '100vh', minHeight: '100dvh', background: '#0a0f1a', color: '#e2e8f0',
          fontFamily: 'system-ui, -apple-system, sans-serif', padding: '24px', textAlign: 'center',
        }}>
          <h1 style={{ color: '#d4af37', fontSize: '1.5rem', marginBottom: '12px' }}>Something went wrong</h1>
          <p style={{ color: '#94a3b8', fontSize: '0.95rem', maxWidth: '400px', lineHeight: 1.6 }}>
            We hit a snag loading Uncharted Travels. This usually fixes itself with a refresh.
          </p>
          <button
            onClick={() => {
              sessionStorage.clear();
              window.location.reload(true);
            }}
            style={{
              marginTop: '20px', padding: '12px 32px', background: '#d4af37', color: '#0a0f1a',
              border: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '1rem', cursor: 'pointer',
            }}
          >
            Reload App
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
